var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_322_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.992 29.6784C22.6846 29.6784 28.9206 23.4424 28.9206 15.7499C28.9206 8.05732 22.6846 1.82129 14.992 1.82129C7.29951 1.82129 1.06348 8.05732 1.06348 15.7499C1.06348 23.4424 7.29951 29.6784 14.992 29.6784Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06348 15.75H28.9206",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3491 15.7499C20.0859 20.8434 18.2098 25.7213 14.9919 29.6784C11.774 25.7213 9.89791 20.8434 9.63477 15.7499C9.89791 10.6563 11.774 5.7784 14.9919 1.82129C18.2098 5.7784 20.0859 10.6563 20.3491 15.7499V15.7499Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(-0.0078125 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurFeature2);
export default __webpack_public_path__ + "static/media/icon-our-feature-2.984a0f4aeef1406c965d107cb9644000.svg";
export { ForwardRef as ReactComponent };